<template>
  <div class="main-frame">
    <div class="info-frame">
      <van-nav-bar title="SMOK" class="top_bar" fixed @click-left="backHome()">
        <template #title>
          <img class="logo-img" src="../assets/image/smoklogo.png" />
        </template>
        <template #left>
          <van-icon name="arrow-left" size="20" color="#000" />
        </template>
      </van-nav-bar>
      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <!-- 提示标题 -->
      <p class="email-input-title">{{ $t("message.B_bind_email") }}</p>
      <van-form @submit="onSubmit">
        <!-- email输入框 -->
        <van-field
          class="input-field"
          v-model="email"
          name="email"
          required
          clearable
          autofocus
          :rules="[{ validator, message: 'Incorrect email format.' }]"
          v-bind:placeholder="$t('message.inform_input_email')"
        />
        <!-- 提示结尾 -->
        <p class="email-input-end">{{ $t("message.B_bind_addr") }}</p>
        <!-- 激活按钮 -->
        <van-button
          class="activate-btn"
          type="info"
          color="#30b3f0"
          native-type="submit"
          >{{ $t("message.B_bind_btn") }}</van-button
        >
        <!-- APP下载 -->
        <van-button
          icon="wap-home-o"
          type="info"
          color="#30b3f0"
          class="download-btn"
          @click="downloadApp"
          >{{ $t("message.home_button_app") }}</van-button
        >
      </van-form>
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
  </div>
</template>

<script>
import Fingerprint2 from "fingerprintjs2";

import foot from "@/components/Foot.vue";
export default {
  components: {
    foot,
  },
  name: "B_bind",
  data() {
    return {
      email: "",
      text: {},
      code: "",
      id: "",
    };
  },
  methods: {
    backHome() {
      this.$router.push({ name: "bind-home" });
    },
    downloadApp() {
      this.$router.push({ name: "home" });
    },
    validator(val) {
      return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val);
    },
    onSubmit(values) {
      // console.log('提交信息:', values.email)
      let _me = this;
      let params = {
        // eslint-disable-next-line no-undef
        access_key: ACCESS_KEY,
        info_code: this.text.info_code,
        activation_code: this.code,
        email: values.email,
        device: this.id == "" ? this.text.device_uuid : this.id,
        subscribe: "1", // 是否订阅 - subscribe 是否订阅(0 不订阅 1订阅)
      };
      _me.common
        .httpPost("anti/fake/activate/new", params)
        .then((res) => {
          // console.log(res);
          switch (res.code) {
            case 100000:
              // 激活成功
              _me.$router.push({
                name: "A_activate",
                params: { data: res.data, status: 1 },
              });
              break;
            case 850005:
              // 激活码不正确
              _me.$router.push({
                name: "B_fake",
                params: { data: _me.text, msg: res.message },
              });
              break;
            case 850009:
              // 激活失败
              _me.$router.push({
                name: "B_fake",
                params: { data: _me.text, msg: res.message },
              });
              break;
            case 850008:
              // 未知状态的防伪码
              _me.$router.push({
                name: "B_fake",
                params: { data: _me.text, msg: res.message },
              });
              break;
            case 850006:
              // 防伪码已经被激活，不能重复激活
              _me.$notify(
                "Anti-counterfeit code has been activated and cannot be activated repeatedly."
              );
              break;
            case 850001:
              // 设备信息不能为空
              _me.$notify(
                "Failed to obtain your device information. Please download IVPS Tour APP to bind."
              );
              break;
            case 850010:
              // 设备已经被锁定
              _me.$notify(res.message);
              break;
            default:
              // 未知错误提示
              _me.$notify("UnKnown Error(-" + res.code + "):", res.message);
              break;
          }
        })
        .catch((err) => {
          // console.err(err)
          _me.$notify("Get Web Data Error:", err.toString());
        });
    },
    getId() {
      // 获取唯一id
      let _me = this;
      let options = {};
      Fingerprint2.get(options, function (components) {
        let values = components.map(function (component) {
          return component.value;
        });
        let murmur = Fingerprint2.x64hash128(values.join(""), 83777975);
        _me.id = murmur;
      });
    },
  },
  created() {
    if (this.$route.params.data != undefined) {
      this.text = this.$route.params.data;
      this.code = this.$route.params.code;
      // 再次获取一下ID
      this.getId();
    } else {
      // 返回主页
      this.$notify(this.$t("message.B_fake_scan"));
      this.$router.push({ name: "bind-home" });
    }
  },
};
</script>

<style scoped>
.main-frame {
  /*width: 100%;*/
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: white;
  text-align: center;
}

.info-frame {
  flex: 1;
}

.top_bar {
  height: 54px;
}

.logo-img {
  margin-top: 4px;
  height: 24px;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.email-input-title {
  margin-left: 16px;
  margin-top: 20px;
  font-size: 12pt;
  text-align: left;
  width: calc(100% - 32px);
}

.input-field {
  margin-left: 16px;
  margin-top: 16px;
  font-size: 12pt;
  width: calc(100% - 32px);
  background-color: #f5f5f5;
  border-radius: 8px;
}

.email-input-end {
  margin-left: 16px;
  margin-top: 8px;
  font-size: 10pt;
  text-align: left;
  color: #777;
  width: calc(100% - 32px);
}

.activate-btn {
  margin-top: 40px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.download-btn {
  margin-top: 16px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}
</style>
